let templateString = require('./device-list-managed.html');

let deviceListManagedController = function(
  $stateParams,
  $q,
  debounce,
  $log,
  DevicesService,
  $state,
  SessionsService,
  ProgressBarService,
  sweet

) {
  let vm = this;
  vm.managingOrgId = undefined;
  ////////////////////////////////////////////////////////////////////////////
  // Managed
  ////////////////////////////////////////////////////////////////////////////
  vm.devices = [];
  vm.devicesPrev = null;
  vm.devicesNext = null;
  vm.selectedButton = "Serial Number";
  vm.serialDevices = {};
  vm.idDevices = {};
  vm.disabled = true;
  vm.macDevices = {};
  vm.gcmidDevices = {};
  vm.throttledSearch = null;

  vm.refreshManagedDevices = function () {
    vm.devicesPrev = null;
    vm.devicesNext = null;
    return vm.getManagedDevices(vm.managingOrgId);
  };

  vm.getManagedDevices = async (key, page) => {
    try {
      vm.loadingDevices = true;
      ProgressBarService.start();
      let devicesPromise = await DevicesService.getDevicesByManagingOrg(key, page);
      console.log('devicesPromise', devicesPromise);
      vm.loadingDevices = false;
      vm.devices = devicesPromise.devices;
      console.log('devices', vm.devices)
      vm.devicesNext = devicesPromise.next;
      vm.devicesPrev = devicesPromise.previous;
    }catch(e) {
      vm.getFetchFailure(e)
    }



    // return devicesPromise.then((function (response) {
    //   vm.loadingDevices = false;
    //   vm.devices = response.devices;
    //   vm.devicesNext = response.next;
    //   vm.devicesPrev = response.previous;
    //   return vm.getFetchSuccess();
    // }), response => vm.getFetchFailure(response));
  };

  vm.getFetchSuccess = () => ProgressBarService.complete();

  vm.getFetchFailure = function (response) {
    ProgressBarService.complete();
    let errorMessage = `Unable to fetch devices. Error: ${response.status} ${response.statusText}.`;
    return sweet.show('Oops...', errorMessage, 'error');
  };

  vm.changeRadio = () => {
    vm.searchText = '';
    vm.disabled = true;
    vm.serialDevices = {};
    vm.idDevices = {};
    vm.macDevices = {};
    vm.devicesToMatchOnManaged = [];
  };
  
  vm.editItem = (item) => {
    DevicesService.editItem(item, false);
  };

  vm.prepareForEditView = function (searchText) {
    let mac, serial, deviceid, gcmid;
    mac = vm.selectedButton === "MAC";
    serial = vm.selectedButton === "Serial Number";
    deviceid = vm.selectedButton === "Device Key";
    gcmid = vm.selectedButton === "GCM ID"
    if (mac) {
      return vm.editItem(vm.macDevices[searchText]);
    } else if (serial) {
      return vm.editItem(vm.serialDevices[searchText]);
    } else if (deviceid) {
      return vm.editItem(vm.idDevices[searchText]);
    } else {
      return vm.editItem(vm.gcmidDevices[searchText])
    }
  };

  vm.controlOpenButton = function (isMatch) {
    vm.disabled = !isMatch;
    vm.disabledButtonLoading = false;
  };

  vm.isResourceValid = function (resource) {
    let devicesToMatchOn = vm.devicesToMatchOnManaged
    let foundMatch = false;
    for (let item of devicesToMatchOn) {
      if (resource === item) {
        foundMatch = true;
      }
    }
    vm.controlOpenButton(foundMatch)
    return foundMatch
  };

  vm.paginateCall = function (forward) {
    if (forward) {
      vm.getManagedDevices(vm.managingOrgId, vm.devicesNext);
    } else {
      vm.getManagedDevices(vm.managingOrgId, vm.devicesPrev);
    }
  };

  

  vm.searchDevices = function (unmanaged = false, partial) {
    let deferred = $q.defer()
    let button = vm.selectedButton;

    let byTenant = false;
    let tenantId = null;

    if (vm.throttledSearch) {
      vm.throttledSearch.cancel();
    }

    vm.throttledSearch = debounce(250, function () {
      DevicesService.searchDevices(partial, button, byTenant, tenantId, vm.managingOrgId, false)
        .then(function (response) {
          // the 0 index is the list of devices as string
          // the 1 index is objects with name as key, values as well, value
          let devicesToReturn;
          if (response.success) {
            let devices = response.devices;
            if (button === "Serial Number") {
              vm.serialDevices = devices[1]
              devicesToReturn = devices[0]
            } else if (button === "Device Key") {
              vm.idDevices = devices[1]
              
              devicesToReturn = devices[0]
            } else if (button === "MAC") {
              vm.macDevices = devices[1]
              devicesToReturn = devices[0]
            } else {
              vm.gcmidDevices = devices[1]
              devicesToReturn = devices[0]
            }
            vm.devicesToMatchOnManaged = devicesToReturn
            deferred.resolve(devicesToReturn)
          } else {
            deferred.resolve([])
          }
        })
    });

    vm.throttledSearch();
    return deferred.promise
  };

  vm.$onInit = () => {
    vm.managingOrgId = SessionsService.getCurrentDistributorKey();
    vm.getManagedDevices(vm.managingOrgId);
    console.log('do inity things', vm.managingOrgId)
  }
}

export let deviceListManaged = {
  template: templateString,
      // bindings: {
      //     heading: '<',
      //     subheading: '<',
      //     details: '<',
      //     showWhen: '<',
      //     onOpen: '<',
      //     onClose: '<'
      // },
      // transclude: true, // allow child DOMs to be added
      controller: deviceListManagedController
  };

angular.module('skykitProvisioning').component('deviceListManaged', deviceListManaged);